function index(obj = {}, i) {
  return obj[i];
}
export default (notation, obj) => notation.split('.').reduce(index, obj);
